if (!window.Eurus.loadedScript.has('tsn-private-quantity.js')) {
  window.Eurus.loadedScript.add('tsn-private-quantity.js');

  document.addEventListener('alpine:init', () => {
      Alpine.data('xTsnPrivateQuantity', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat,
        quantityPriceBreaks = [],
        cartQtyVariant = 0,
        productHandle,
        variantId
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        stockPending: false,
        stockRequest: 0,
        init() {
          this.$root.tsnStockQuantity = this;
        },
        destroy() {
          this.stockRequest++;
          if (this.quantityChangeListener) document.removeEventListener(`eurus:product:quantity-changed-${sectionId}`, this.quantityChangeListener);
          delete this.$root.tsnStockQuantity;
        },
        async stockAllowed(quantity) {
          const form = this.$root.querySelector('input[name="quantity"]')?.form;
          const currentVariant = form?.elements.namedItem('id')?.value || variantId;
          return window.TSNStockPrivacy.check(productHandle, currentVariant, quantity);
        },
        showStockError(message) {
          this.errInventory = true;
          const error = this.$root.querySelector('.quantity-err-inventory');
          if (error) error.textContent = message || window.TSNStockPrivacy.unavailable;
        },
        errInventory: false,
        errIncrement: false,
        errMax: false,
        initQtyChangeEvent(selector) {
          this.$nextTick(() => {
            this.qty = document.getElementById(selector)?.value;
            if (this.quantityChangeListener) document.removeEventListener(`eurus:product:quantity-changed-${sectionId}`, this.quantityChangeListener);
            this.quantityChangeListener = (e) => {
              this.stockRequest++;
              this.qty = e.detail.quantity;
              this.updatePrice();
            };
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, this.quantityChangeListener);
          });
        },
        minus(value) {
          this.stockRequest++;
          if (this.qty - value <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty = Math.ceil((this.qty - value) / value) * value;
          }
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          this.updatePrice();
        },
        async plus(value) {
          if (this.stockPending) return;
          const step = value > 0 ? value : 1;
          let candidate = Number(this.qty) - Number(this.qty) % step + step;
          if (this.max != null) candidate = Math.min(candidate, this.max - cartQtyVariant);
          if (candidate < this.min || candidate <= Number(this.qty)) { this.showStockError(); return; }
          const request = ++this.stockRequest;
          const previous = Number(this.qty);
          this.stockPending = true;
          try {
            const allowed = await this.stockAllowed(candidate);
            if (request !== this.stockRequest || !this.$root.isConnected || Number(this.qty) !== previous) return;
            this.errIncrement = false;
            this.errMax = false;
            this.errInventory = !allowed;
            if (allowed) { this.qty = candidate; this.updatePrice(); }
            else this.showStockError();
          } catch (_) {
            if (request === this.stockRequest) this.showStockError(window.TSNStockPrivacy.retry);
          } finally { this.stockPending = false; }
        },
        async invalid(el, qtyRuleIncrement) {
          const request = ++this.stockRequest;
          const number = parseFloat(el.value);
          this.errIncrement = false;
          this.errMax = false;
          this.errInventory = false;
          if (!Number.isInteger(number) || number < 1) {
            this.qty = this.min;
            this.updatePrice();
          }
          if (this.max != null && number > (this.max - cartQtyVariant)) {
            this.errMax = true;
          } else if (number % qtyRuleIncrement != 0) {
            this.errIncrement = true; 
          } else {
            this.updatePrice();
            if (!Number.isInteger(number) || number < this.min) return;
            try {
              const allowed = await this.stockAllowed(number);
              if (request === this.stockRequest && Number(this.qty) === number && this.$root.isConnected && !allowed) this.showStockError();
            } catch (_) {
              if (request === this.stockRequest) this.showStockError(window.TSNStockPrivacy.retry);
            }
          }
        },
        updatePrice() {
          const productTemplate = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          if (!productTemplate) return;
          const moneyFormatType = currencyCodeEnable ? moneyWithCurrency : moneyFormat;
          const formatMoney = (amount) => Alpine.store('xHelper').formatMoney(amount, moneyFormatType);
          const update = (selector, value) => {
            productTemplate.querySelectorAll(selector).forEach((el) => el.innerHTML = value);
          };
          const unitPrice = Number(productTemplate.querySelector('.target-price')?.innerHTML) || 0;
          const compareAtPrice = Number(productTemplate.querySelector('.target-compare-at-price')?.innerHTML) || 0;
          let currentPrice = unitPrice;
          for (let i = 0; i < quantityPriceBreaks.length; i++) {
            if ((Number(this.qty) + cartQtyVariant) >= quantityPriceBreaks[i].minimum_quantity) {
              currentPrice = quantityPriceBreaks[i].price;
            }
          }
          update('.add_to_cart_button .main-product-price .price', formatMoney(currentPrice * this.qty));
          update('.add_to_cart_button .main-product-price .price-sale', formatMoney(currentPrice * this.qty));
          update('.add_to_cart_button .main-product-price .price-compare', formatMoney(compareAtPrice * this.qty));
          if (quantityPriceBreaks.length > 0) {
            update('.add_to_cart_button .main-product-price .unit-price', formatMoney(currentPrice));
            update(`#price-${sectionId}-${productId}`, formatMoney(currentPrice));
          }
          document.dispatchEvent(new CustomEvent(`quantity:changed-${sectionId}`, {
            detail: {
              qty: this.qty
            }
          }));
        },
      }));
    })
}    
